import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const BillingAddressToggleWrapper = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    return (
      <div {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Billing Address Toggle',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  constraints: {
    descendants: [
      {is: 'CommerceCheckoutBillingAddressToggleCheckbox', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutBillingAddressToggleLabel', rule: 'ExactlyOne'},
    ],
    ancestors: [{is: 'CommerceCheckoutFormContainer', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'row',
        },
      },
    },
  },
  showEmpty: false,
  render: BillingAddressToggleWrapper,
  fields: {children: TListOfElement},
});

export default config;
